import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import * as Sentry from "@sentry/react";

import { getCurrentEnvironment } from "../utils/get-current-environment";

const environment = getCurrentEnvironment();

Sentry.init({
  dsn: "https://24deda7f60849868aad173feba60d2ea@o390735.ingest.us.sentry.io/4509348878811136",
  tunnel: new URL("monitoring", import.meta.env.VITE_API_URL).toString(),
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn"] }),
    Sentry.replayIntegration({
      mask: ["[data-sentry-mask]"],
      maskAllText: false,
    }),
  ],
  _experiments: { enableLogs: true },
  normalizeDepth: 5,
  environment,
  enabled: environment !== "local",
  // Performance Monitoring
  tracesSampleRate: environment === "development" ? 0.5 : 0.3,
  tracePropagationTargets: ["localhost", import.meta.env.VITE_API_URL],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
